import { CommonModule } from '@angular/common';
import { Component, ContentChild, ElementRef, Input, OnInit } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { TranslateModule } from '@ngx-translate/core';
import { FiltersService } from 'src/app/services/filters.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { PencilButtonComponent } from '../pencil-button/pencil-button.component';
import { IconTypes, PencilIconComponent } from '../pencil-icon/pencil-icon.component';
import { FilterKey } from '../generic-filters-view/filters.interface';

@UntilDestroy()
@Component({
  selector: 'app-generic-pencil-filter[title]',
  templateUrl: './generic-pencil-filter.component.html',
  styleUrls: ['./generic-pencil-filter.component.scss'],
  standalone: true,
  imports: [
    MatExpansionModule,
    TranslateModule,
    CommonModule,
    PencilButtonComponent,
    PencilIconComponent,
  ],
})
export class GenericPencilFilterComponent implements OnInit {
  @ContentChild('ng-content') ngContent?: ElementRef;
  @Input() title: string = '';
  @Input() hasDivider: boolean = true;
  @Input() isLocked: boolean = false;
  @Input() filterKey: FilterKey = '';

  showClearButton: boolean = false;
  panelOpenState: boolean = false;

  protected IconTypes = IconTypes;

  constructor(public filtersService: FiltersService) {}

  ngOnInit(): void {
    this.filtersService.appliedFilters$.pipe(untilDestroyed(this)).subscribe((filters) => {
      this.showClearButton =
        !!filters.find((filter) => filter.key === this.filterKey) && !this.isLocked;
    });
  }

  resetFilter(event: Event) {
    event.stopPropagation();
    this.filtersService.removeFilter(this.filterKey);
  }
}
